// extracted by mini-css-extract-plugin
module.exports = {"menuA":"MenuAcess_menuA__sFCku","menuActive":"MenuAcess_menuActive__3uTQJ","imageMenu":"MenuAcess_imageMenu__FCQdC","linkMenu":"MenuAcess_linkMenu__sca2u"};